import { uid } from 'src/utils/random';
import { request as addLeg } from './add-leg';
import { request as addBet } from './add-bet';

const NAMES = {
    FC: 'Forecast',
    RFC: 'Reverse Forecast'
};

export function request(userId, type, legs) {
    console.info('add Forecast userId, type, legs', {userId, type, legs});

    legs = legs.map(leg => {
        return ({
            uid: uid(),
            eventId: leg.eventId,
            marketId: leg.marketId,
            selectionId: leg.selectionId,
            price: leg.price,
            priceType: leg.priceType,
            isMarketSp: leg.isMarketSp,
            numLines: 1
        });
    });

    let bet = {
        type: type,
        name: NAMES[type],
        ewOffered: true,
        numLines: 1,
        stakePerLine: 0,
        legs: legs.map(l => l.uid)
    };

    return (dispatch) => {
        legs.forEach(leg => dispatch(addLeg(userId, leg)));
        dispatch(addBet(userId, bet));
    };
}
